import { memo, useState } from "react"
import { Box, HStack, VStack, FormControl, FormErrorMessage, FormLabel, Skeleton } from '@chakra-ui/react'
import { TableQrCardModal } from "./TableQrCardModal";
import { ReactSelectWithChakraStyle } from "../../../atoms/ReactSelectWithChakraStyle";
import { SelectOption } from '../../../../types/select';

type Table = {
  id: string;
  table_name: string;
  qr_code: string;
  in_use: boolean;
  auth_code: number;
}

type Tables = Table[];

type TableQrCardsSectionProps = {
  isLoading?: boolean;
  label?: string;
  options: SelectOption[];
  onChange: (value: number | string | null) => void;
  error?: string;
  tableChoices: Tables;
}

export const TableQrCardsSection: React.FC<TableQrCardsSectionProps> = memo(({ isLoading, label = 'テーブル', options, onChange, error, tableChoices }) => {
  const [selectedRange, setSelectedRange] = useState<{ start: number; end: number } | null>(null);

  const handleSelectChange = (option: SelectOption | null) => {
    onChange(option?.value ?? null);
    
    if (option) {
      // オプションの値から開始テーブル番号を取得
      const startValue = parseInt(option.value.toString());
      
      // ラベルから範囲を解析（例: "1〜12"）
      const match = option.label.toString().match(/(\d+)〜(\d+)/);
      if (match && match.length === 3) {
        const endValue = parseInt(match[2]);
        setSelectedRange({ start: startValue, end: endValue });
      } else {
        // 単一テーブルの場合
        setSelectedRange({ start: startValue, end: startValue });
      }
    } else {
      setSelectedRange(null);
    }
  };

  return (
    <FormControl isInvalid={!!error} isRequired w='100%' mb={4}>
      <VStack align="flex-start" spacing={3} w="100%">
        <FormLabel>{label}（12枚単位で選択）</FormLabel>
        
        <Skeleton isLoaded={!isLoading} w='100%' paddingBottom={5} borderRadius={5}>
          <ReactSelectWithChakraStyle
            placeholder="選択"
            options={options}
            onChange={handleSelectChange}
            formatOptionLabel={({ label }) => (
              <HStack>
                <Box>テーブル</Box>
                <Box
                  px={2}
                  textAlign="center"
                  fontSize="12px"
                  fontWeight="bold"
                  backgroundColor="#0078FF"
                  color="white"
                  borderRadius="4px"
                >
                  {label}
                </Box>
              </HStack>
            )}
          />
        </Skeleton>

        {selectedRange && (
          <Skeleton isLoaded={!isLoading} w='100%' borderRadius={5}>
            <TableQrCardModal
              tables={tableChoices.slice(selectedRange.start - 1, selectedRange.end)}
            />
          </Skeleton>
        )}
        
        <FormErrorMessage>{error}</FormErrorMessage>
      </VStack>
    </FormControl>
  );
});